import React from 'react';
import { Box, Typography, Button, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { BRAND } from '../../config/brand';
import {
  useGetDeliveriesQuery,
  useUpdateDeliveryStatusMutation,
} from '../../api/deliveryApi';
import EntityDataTable, { EntityColumn } from '../common/EntityDataTable';

const STATUS_FLOW = ['pending', 'packed', 'dispatched', 'in_transit', 'delivered'];

export const DeliveryManagement: React.FC = () => {
  const { data: deliveries = [], isLoading, refetch } = useGetDeliveriesQuery();
  const [updateStatus] = useUpdateDeliveryStatusMutation();

  const columns: EntityColumn<Record<string, any>>[] = [
    { id: 'trackingNumber', label: 'Tracking #' },
    { id: 'carrier', label: 'Carrier' },
    {
      id: 'customer',
      label: 'Customer',
      render: (row) => row.order?.customer?.name || '—',
    },
    {
      id: 'workOrder',
      label: 'Work Order',
      render: (row) => row.workOrder?.workOrderNumber || '—',
    },
    {
      id: 'estimatedDelivery',
      label: 'Est. Delivery',
      render: (row) => row.estimatedDelivery ? new Date(row.estimatedDelivery).toLocaleDateString() : '—',
    },
    {
      id: 'actions',
      label: 'Update',
      render: (row) => (
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <Select
            value={row.status}
            onChange={async (e) => {
              await updateStatus({ id: row.id, status: e.target.value });
              refetch();
            }}
          >
            {STATUS_FLOW.map((s) => (
              <MenuItem key={s} value={s}>{s}</MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ color: BRAND.colors.navy, fontWeight: 700, mb: 3 }}>
        Delivery Management
      </Typography>

      <EntityDataTable
        data={deliveries as any[]}
        columns={columns}
        statusField="status"
        statusColors={{
          pending: 'warning',
          packed: 'info',
          dispatched: 'primary',
          in_transit: 'secondary',
          delivered: 'success',
          failed: 'error',
        }}
        searchFields={['trackingNumber', 'carrier']}
        loading={isLoading}
      />
    </Box>
  );
};

export default DeliveryManagement;
